module.exports = __webpack_public_path__ + "img/cp32_03.b2f7966a.jpg";